import { Drawer as MantineDrawer } from "@mantine/core";

export const Drawer = MantineDrawer;
